import barba from "@barba/core";

const initArrowLink = () => {
	const arrowLinks = document.querySelectorAll(
		".is-style-arrow-link:not(.is-initialized)"
	);

	if(arrowLinks.length) {
		arrowLinks.forEach((arrowLink) => {
			arrowLink.classList.add("is-initialized");

			let arrow = document.createElement("span");
			arrow.classList.add("arrow-wrapper");
			arrow.innerHTML =
				"<svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='currentColor' fill-rule='evenodd'><path d='m22.7 7.22-.48.65 13.13 14.99v.17H0v1.94h35.35v.25L22.22 40.13l.48.65L48 24.08v-.24L22.7 7.22z'/></svg>";

			arrowLink.appendChild(arrow);
		});
	}
};

barba.hooks.beforeEnter(initArrowLink);
document.addEventListener("DOMContentLoaded", initArrowLink);
